import { AuthenticatedRoute, UnauthenticatedRoute } from 'components/Route';
import React from 'react';
import { Switch } from 'react-router';
import StoreContextWrapper from 'utilities/StoreContextWrapper';
import { UseScrollToTop } from 'utilities/UseScrollToTop';
import Agenda from './Agenda';
import Ambassadors from './Ambassadors/Ambassadors';
import Dashboard from './Dashboard';
import Groei from './Groei';
import Group from './Group';
import Home from './Home';
import Match from './Match';
import News from './News';
import OverOrion from './OverOrion';
import Page from './Page';
import Evaluation from './Evaluation';
import Network from './Network';

export default function Routes() {
    UseScrollToTop();

    return (
        <StoreContextWrapper>
            <Switch>
                <UnauthenticatedRoute path="/" exact component={Home} />
                {/* Analytics modal slug fix */}
                <UnauthenticatedRoute path="/contact-popup" component={Home} />
                <UnauthenticatedRoute
                    path="/nieuwsbrief-popup"
                    component={Home}
                />
                <UnauthenticatedRoute
                    path="/instellingen-popup"
                    component={Home}
                />
                {/*  */}
                <UnauthenticatedRoute path="/groei" component={Groei} />
                <UnauthenticatedRoute
                    path="/school-aanbod/:slug"
                    component={Groei}
                />
                <UnauthenticatedRoute
                    path="/orion-vacatures"
                    component={Match}
                />
                <UnauthenticatedRoute path="/nieuws" component={News} />
                <UnauthenticatedRoute path="/agenda" component={Agenda} />
                <UnauthenticatedRoute
                    path="/evaluatie"
                    component={Evaluation}
                />
                <UnauthenticatedRoute
                    path="/ambassadeurs"
                    component={Ambassadors}
                />
                <UnauthenticatedRoute
                    path="/netwerk"
                    component={Network}
                />
                <UnauthenticatedRoute
                    path="/over-orion"
                    component={OverOrion}
                />
                <AuthenticatedRoute path="/dashboard" component={Dashboard} />
                <AuthenticatedRoute path="/group/:id" component={Group} />

                <UnauthenticatedRoute path="/:slug" component={Page} />
            </Switch>
        </StoreContextWrapper>
    );
}
